export function auditoriaInRequest(params = {}) {
    return {
        type: '@auditoriaitem/AUDITORIAITEM_IN_REQUEST',
        payload: { params },
    };
}

export function failedRequest() {
    return {
        type: '@auditoria/FAILED_REQUEST',
    };
}

export function successInRequest(
    auditoriaitem,
    page,
    pageSize,
    totalCount,
    totalPages
) {
    return {
        type: '@auditoriaitem/SUCCESS_IN_REQUEST',
        payload: { auditoriaitem, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(auditoriaitem) {
    return {
        type: '@auditoriaitem/SUCCESS_REQUEST',
        payload: { auditoriaitem },
    };
}



export function recordFiltering(params) {
    return {
        type: '@auditoriaitem/RECORD_FILTERING',
        payload: { params },
    };
}
